export enum VerticalPosition {
  TOP = "top",
  CENTER = "center",
  BOTTOM = "bottom"
}
export enum HorizontalPosition {
  LEFT = "left",
  CENTER = "center",
  RIGHT = "right"
}

export function invertPosition(pos: HorizontalPosition): HorizontalPosition;
export function invertPosition(pos: VerticalPosition): VerticalPosition;
export function invertPosition(
  pos: HorizontalPosition | VerticalPosition
): HorizontalPosition | VerticalPosition {
  switch (pos) {
    case HorizontalPosition.LEFT:
      return HorizontalPosition.RIGHT;
    case HorizontalPosition.RIGHT:
      return HorizontalPosition.LEFT;
    case VerticalPosition.TOP:
      return VerticalPosition.BOTTOM;
    case VerticalPosition.BOTTOM:
      return VerticalPosition.TOP;
    default:
      return pos;
  }
}
